// extracted by mini-css-extract-plugin
module.exports = {"container":"PageWithMenu_container__YL_Qx","menu":"PageWithMenu_menu__y5aWu","wrapper":"PageWithMenu_wrapper__bllQd"};